/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from "react";
import Loadable from "react-loadable";

//import Amenities from 'components/containers/Amenities';
const Amenities = Loadable({
  loader: () => import("components/containers/Amenities"),
  loading: () => <div> </div>,
  modules: ["Amenities"],
});

//import AnchorCTA from 'components/containers/AnchorCTA';
const AnchorCTA = Loadable({
  loader: () => import("components/containers/AnchorCTA"),
  loading: () => <div> </div>,
  modules: ["AnchorCTA"],
});

//import AnchorLinkBar from 'components/containers/AnchorLinkBar';
const AnchorLinkBar = Loadable({
  loader: () => import("components/containers/AnchorLinkBar"),
  loading: () => <div> </div>,
  modules: ["AnchorLinkBar"],
});

//import AvailablePromos from 'components/containers/AvailablePromos';
const AvailablePromos = Loadable({
  loader: () => import("components/containers/AvailablePromos"),
  loading: () => <div> </div>,
  modules: ["AvailablePromos"],
});

//import BackButton from 'components/containers/BackButton';
const BackButton = Loadable({
  loader: () => import("components/containers/BackButton"),
  loading: () => <div> </div>,
  modules: ["BackButton"],
});

//import BackButtonBar from 'components/containers/BackButtonBar';
const BackButtonBar = Loadable({
  loader: () => import("components/containers/BackButtonBar"),
  loading: () => <div> </div>,
  modules: ["BackButtonBar"],
});

//import Banner from 'components/containers/Banner';
const Banner = Loadable({
  loader: () => import("components/containers/Banner"),
  loading: () => <div> </div>,
  modules: ["Banner"],
});

//import Breadcrumb from 'components/containers/Breadcrumb';
const Breadcrumb = Loadable({
  loader: () => import("components/containers/Breadcrumb"),
  loading: () => <div> </div>,
  modules: ["Breadcrumb"],
});

//import BreadcrumbSchema from 'components/containers/BreadcrumbSchema';
const BreadcrumbSchema = Loadable({
  loader: () => import("components/containers/BreadcrumbSchema"),
  loading: () => <div> </div>,
  modules: ["BreadcrumbSchema"],
});

//import ButtonCTA from 'components/containers/ButtonCTA';
const ButtonCTA = Loadable({
  loader: () => import("components/containers/ButtonCTA"),
  loading: () => <div> </div>,
  modules: ["ButtonCTA"],
});

//import Cards from 'components/containers/Cards';
const Cards = Loadable({
  loader: () => import("components/containers/Cards"),
  loading: () => <div> </div>,
  modules: ["Cards"],
});

//import ChatBot from 'components/containers/ChatBot';
const ChatBot = Loadable({
  loader: () => import("components/containers/ChatBot"),
  loading: () => <div> </div>,
  modules: ["ChatBot"],
});

//import ColumnsBlock from 'components/containers/ColumnsBlock';
const ColumnsBlock = Loadable({
  loader: () => import("components/containers/ColumnsBlock"),
  loading: () => <div> </div>,
  modules: ["ColumnsBlock"],
});

//import CommunityCards from 'components/containers/CommunityCards';
const CommunityCards = Loadable({
  loader: () => import("components/containers/CommunityCards"),
  loading: () => <div> </div>,
  modules: ["CommunityCards"],
});

//import CommunityMap from 'components/containers/CommunityMap';
const CommunityMap = Loadable({
  loader: () => import("components/containers/CommunityMap"),
  loading: () => <div> </div>,
  modules: ["CommunityMap"],
});
//import CommunityMap from 'components/containers/CommunityMap';
const CommunityProductOverview = Loadable({
  loader: () => import("components/containers/CommunityProductOverview"),
  loading: () => <div> </div>,
  modules: ["CommunityProductOverview"],
});

//import CommunitySchema from 'components/containers/CommunitySchema';
const CommunitySchema = Loadable({
  loader: () => import("components/containers/CommunitySchema"),
  loading: () => <div> </div>,
  modules: ["CommunitySchema"],
});

//import CommunityServices from 'components/containers/CommunityServices';
const CommunityServices = Loadable({
  loader: () => import("components/containers/CommunityServices"),
  loading: () => <div> </div>,
  modules: ["CommunityServices"],
});

//import CommunityStylesCards from 'components/containers/CommunityStylesCards';
const CommunityStylesCards = Loadable({
  loader: () => import("components/containers/CommunityStylesCards"),
  loading: () => <div> </div>,
  modules: ["CommunityStylesCards"],
});

//import ContactCards from 'components/containers/ContactCards';
const ContactCards = Loadable({
  loader: () => import("components/containers/ContactCards"),
  loading: () => <div> </div>,
  modules: ["ContactCards"],
});

//import CondoiFrame from 'components/containers/CondoiFrame';
const CondoiFrame = Loadable({
  loader: () => import("components/containers/CondoiFrame"),
  loading: () => <div> </div>,
  modules: ["CondoiFrame"],
});

//import CondoOptions from 'components/containers/CondoOptions';
const CondoOptions = Loadable({
  loader: () => import("components/containers/CondoOptions"),
  loading: () => <div> </div>,
  modules: ["CondoOptions"],
});

//import ContactPanel from 'components/containers/ContactPanel';
const ContactPanel = Loadable({
  loader: () => import("components/containers/ContactPanel"),
  loading: () => <div> </div>,
  modules: ["ContactPanel"],
});

//import ContactUsPanel from 'components/containers/ContactUsPanel';
const ContactUsPanel = Loadable({
  loader: () => import("components/containers/ContactUsPanel"),
  loading: () => <div> </div>,
  modules: ["ContactUsPanel"],
});

//import CountrySelector from 'components/containers/CountrySelector';
const CountrySelector = Loadable({
  loader: () => import("components/containers/CountrySelector"),
  loading: () => <div> </div>,
  modules: ["CountrySelector"],
});

//import CustomCare from 'components/containers/CustomCare';
const CustomCare = Loadable({
  loader: () => import("components/containers/CustomCare"),
  loading: () => <div> </div>,
  modules: ["CustomCare"],
});

//import DynamicWidthGallerySection from 'components/containers/DynamicWidthGallerySection';
const DynamicWidthGallerySection = Loadable({
  loader: () => import("components/containers/DynamicWidthGallery"),
  loading: () => <div> </div>,
  modules: ["DynamicWidthGallerySection"],
});

//import DisclaimerText from 'components/containers/DisclaimerText';
const DisclaimerText = Loadable({
  loader: () => import("components/containers/DisclaimerText"),
  loading: () => <div> </div>,
  modules: ["DisclaimerText"],
});

//import DoubleMedia from 'components/containers/DoubleMedia';
const DoubleMedia = Loadable({
  loader: () => import("components/containers/DoubleMedia"),
  loading: () => <div> </div>,
  modules: ["DoubleMedia"],
});

//import EloquaIntegrationData from 'components/containers/EloquaIntegrationData';
const EloquaIntegrationData = Loadable({
  loader: () => import("components/containers/EloquaIntegrationData"),
  loading: () => <div> </div>,
  modules: ["EloquaIntegrationData"],
});

//import ExpansionContent from 'components/containers/ExpansionContent';
const ExpansionContent = Loadable({
  loader: () => import("components/containers/ExpansionContent"),
  loading: () => <div> </div>,
  modules: ["ExpansionContent"],
});

//import ExpansionFeatures from 'components/containers/ExpansionFeatures';
const ExpansionFeatures = Loadable({
  loader: () => import("components/containers/ExpansionFeatures"),
  loading: () => <div> </div>,
  modules: ["ExpansionFeatures"],
});

//import ExtendedGallerySection from 'components/containers/ExtendedGallerySection';
const ExtendedGallerySection = Loadable({
  loader: () => import("components/containers/ExtendedGallerySection"),
  loading: () => <div> </div>,
  modules: ["ExtendedGallerySection"],
});

//import ExteriorStyles from 'components/containers/ExteriorStyles';
const ExteriorStyles = Loadable({
  loader: () => import("components/containers/ExteriorStyles"),
  loading: () => <div> </div>,
  modules: ["ExteriorStyles"],
});

//import FAQsContainer from 'components/containers/FAQsContainer';
const FAQsContainer = Loadable({
  loader: () => import("components/containers/FAQsContainer"),
  loading: () => <div> </div>,
  modules: ["FAQsContainer"],
});

//import Favicon from 'components/containers/Favicon';
const Favicon = Loadable({
  loader: () => import("components/containers/Favicon"),
  loading: () => <div> </div>,
  modules: ["Favicon"],
});

//import FloorPlan from 'components/containers/FloorPlan';
const FloorPlan = Loadable({
  loader: () => import("components/containers/FloorPlan"),
  loading: () => <div> </div>,
  modules: ["FloorPlan"],
});

//import FloorplanSchema from 'components/containers/FloorplanSchema';
const FloorplanSchema = Loadable({
  loader: () => import("components/containers/FloorplanSchema"),
  loading: () => <div> </div>,
  modules: ["FloorplanSchema"],
});

//import Footer from 'components/containers/Footer';
const Footer = Loadable({
  loader: () => import("components/containers/Footer"),
  loading: () => <div> </div>,
  modules: ["Footer"],
});

//import Form from 'components/containers/Form';
const Form = Loadable({
  loader: () => import("components/containers/Form"),
  loading: () => <div> </div>,
  modules: ["Form"],
});

//import FormsConfirmationModal from 'components/containers/FormsConfirmationModal';
const FormsConfirmationModal = Loadable({
  loader: () => import("components/containers/FormsConfirmationModal"),
  loading: () => <div> </div>,
  modules: ["FormsConfirmationModal"],
});

//import FormsMarketCommunities from 'components/containers/FormsMarketCommunities';
const FormsMarketCommunities = Loadable({
  loader: () => import("components/containers/FormsMarketCommunities"),
  loading: () => <div> </div>,
  modules: ["FormsMarketCommunities"],
});

//import FormsTitle from 'components/containers/FormsTitle';
const FormsTitle = Loadable({
  loader: () => import("components/containers/FormsTitle"),
  loading: () => <div> </div>,
  modules: ["FormsTitle"],
});

//import GalleryComponent from 'components/containers/GalleryComponent';
const GalleryComponent = Loadable({
  loader: () => import("components/containers/GalleryComponent"),
  loading: () => <div> </div>,
  modules: ["GalleryComponent"],
});

//import GallerySection from 'components/containers/GallerySection';
const GallerySection = Loadable({
  loader: () => import("components/containers/GallerySection"),
  loading: () => <div> </div>,
  modules: ["GallerySection"],
});

//import GeneralScript from 'components/containers/GeneralScript';
const GeneralScript = Loadable({
  loader: () => import("components/containers/GeneralScript"),
  loading: () => <div> </div>,
  modules: ["GeneralScript"],
});

//import GenericFormContainer from 'components/containers/GenericFormContainer';
const GenericFormContainer = Loadable({
  loader: () => import("components/containers/GenericFormContainer"),
  loading: () => <div> </div>,
  modules: ["GenericFormContainer"],
});

//import GetInTouch from 'components/containers/GetInTouch';
const GetInTouch = Loadable({
  loader: () => import("components/containers/GetInTouch"),
  loading: () => <div> </div>,
  modules: ["GetInTouch"],
});

//import GetInTouchContainer from 'components/containers/GetInTouchContainer';
const GetInTouchContainer = Loadable({
  loader: () => import("components/containers/GetInTouchContainer"),
  loading: () => <div> </div>,
  modules: ["GetInTouchContainer"],
});

//import GTM from 'components/containers/GTM';
const GTM = Loadable({
  loader: () => import("components/containers/GTM"),
  loading: () => <div> </div>,
  modules: ["GTM"],
});

//import Header from 'components/containers/Header';
const Header = Loadable({
  loader: () => import("components/containers/Header"),
  loading: () => <div> </div>,
  modules: ["Header"],
});

//import HomeCutaway from 'components/containers/HomeCutaway';
const HomeCutaway = Loadable({
  loader: () => import("components/containers/HomeCutaway"),
  loading: () => <div> </div>,
  modules: ["HomeCutaway"],
});

//import HomeSpecsBlock from 'components/containers/HomeSpecsBlock';
const HomeSpecsBlock = Loadable({
  loader: () => import("components/containers/HomeSpecsBlock"),
  loading: () => <div> </div>,
  modules: ["HomeSpecsBlock"],
});

//import ImageVideo from 'components/containers/ImageVideo';
const ImageVideo = Loadable({
  loader: () => import("components/containers/ImageVideo"),
  loading: () => <div> </div>,
  modules: ["ImageVideo"],
});

//import ImageVideoForCareers from 'components/containers/ImageVideoForCareers';
const ImageVideoForCareers = Loadable({
  loader: () => import("components/containers/ImageVideoForCareers"),
  loading: () => <div> </div>,
  modules: ["ImageVideoForCareers"],
});

//import InteractiveSitemap from 'components/containers/InteractiveSitemap';
const InteractiveSitemap = Loadable({
  loader: () => import("components/containers/InteractiveSitemap"),
  loading: () => <div> </div>,
  modules: ["InteractiveSitemap"],
});

//import InvestorRelationsForm from 'components/containers/InvestorRelationsForm';
const InvestorRelationsForm = Loadable({
  loader: () => import("components/containers/InvestorRelationsForm"),
  loading: () => <div> </div>,
  modules: ["InvestorRelationsForm"],
});

//import LargeTitleAndText from 'components/containers/LargeTitleAndText';
const LargeTitleAndText = Loadable({
  loader: () => import("components/containers/LargeTitleAndText"),
  loading: () => <div> </div>,
  modules: ["LargeTitleAndText"],
});

//import MarketCards from 'components/containers/MarketCards';
const MarketCards = Loadable({
  loader: () => import("components/containers/MarketCards"),
  loading: () => <div> </div>,
  modules: ["MarketCards"],
});

//import MarketCardsWrapper from 'components/containers/MarketCardsWrapper';
const MarketCardsWrapper = Loadable({
  loader: () => import("components/containers/MarketCardsWrapper"),
  loading: () => <div> </div>,
  modules: ["MarketCardsWrapper"],
});

//import MarketSelector from 'components/containers/MarketSelector';
const MarketSelector = Loadable({
  loader: () => import("components/containers/MarketSelector"),
  loading: () => <div> </div>,
  modules: ["MarketSelector"],
});

//import Masthead from 'components/containers/Masthead';
const Masthead = Loadable({
  loader: () => import("components/containers/Masthead"),
  loading: () => <div> </div>,
  modules: ["Masthead"],
});

//import MetroSearch from 'components/containers/MetroSearch';
const MetroSearch = Loadable({
  loader: () => import("components/containers/MetroSearch"),
  loading: () => <div> </div>,
  modules: ["MetroSearch"],
});

//import MortgageCalculator from 'components/containers/MortgageCalculator';
const MortgageCalculator = Loadable({
  loader: () => import("components/containers/MortgageCalculator"),
  loading: () => <div> </div>,
  modules: ["MortgageCalculator"],
});

//import MultiBlocks from 'components/containers/MultiBlocks';
const MultiBlocks = Loadable({
  loader: () => import("components/containers/MultiBlocks"),
  loading: () => <div> </div>,
  modules: ["MultiBlocks"],
});

//import MyHomeStory from 'components/containers/MyHomeStory';
const MyHomeStory = Loadable({
  loader: () => import("components/containers/MyHomeStory"),
  loading: () => <div> </div>,
  modules: ["MyHomeStory"],
});

//import NationalPromoBanner from 'components/containers/NationalPromoBanner';
const NationalPromoBanner = Loadable({
  loader: () => import("components/containers/NationalPromoBanner"),
  loading: () => <div> </div>,
  modules: ["NationalPromoBanner"],
});

//import NotificationBanner from 'components/containers/NotificationBanner';
const NotificationBanner = Loadable({
  loader: () => import("components/containers/NotificationBanner"),
  loading: () => <div> </div>,
  modules: ["NotificationBanner"],
});

//import OpenGraph from 'components/containers/OpenGraph';
const OpenGraph = Loadable({
  loader: () => import("components/containers/OpenGraph"),
  loading: () => <div> </div>,
  modules: ["OpenGraph"],
});

//import PageNotFound from 'components/containers/PageNotFound';
const PageNotFound = Loadable({
  loader: () => import("components/containers/PageNotFound"),
  loading: () => <div> </div>,
  modules: ["PageNotFound"],
});

//import PlanDescription from 'components/containers/PlanDescription';
const PlanDescription = Loadable({
  loader: () => import("components/containers/PlanDescription"),
  loading: () => <div> </div>,
  modules: ["PlanDescription"],
});

//import PortraitCards from 'components/containers/PortraitCards';
const PortraitCards = Loadable({
  loader: () => import("components/containers/PortraitCards"),
  loading: () => <div> </div>,
  modules: ["PortraitCards"],
});

//import ProductCarousel from 'components/containers/ProductCarousel';
const ProductCarousel = Loadable({
  loader: () => import("components/containers/ProductCarousel"),
  loading: () => <div> </div>,
  modules: ["ProductCarousel"],
});

//import ProductHero from 'components/containers/ProductHero';
const ProductHero = Loadable({
  loader: () => import("components/containers/ProductHero"),
  loading: () => <div> </div>,
  modules: ["ProductHero"],
});

//import ProductOverview from 'components/containers/ProductOverview';
const ProductOverview = Loadable({
  loader: () => import("components/containers/ProductOverview"),
  loading: () => <div> </div>,
  modules: ["ProductOverview"],
});

//import ProductSection from 'components/containers/ProductSection';
const ProductSection = Loadable({
  loader: () => import("components/containers/ProductSection"),
  loading: () => <div> </div>,
  modules: ["ProductSection"],
});

//import Promo from 'components/containers/Promo';
const Promo = Loadable({
  loader: () => import("components/containers/Promo"),
  loading: () => <div> </div>,
  modules: ["Promo"],
});

//import PromoBlock from 'components/containers/PromoBlock';
const PromoBlock = Loadable({
  loader: () => import("components/containers/PromoBlock"),
  loading: () => <div> </div>,
  modules: ["PromoBlock"],
});

//import PromosFlyout from 'components/containers/PromosFlyout';
const PromosFlyout = Loadable({
  loader: () => import("components/containers/PromosFlyout"),
  loading: () => <div> </div>,
  modules: ["PromosFlyout"],
});

//import PromosFlyout from 'components/containers/PromosFlyout';
const QMISchema = Loadable({
  loader: () => import("components/containers/QMISchema"),
  loading: () => <div> </div>,
  modules: ["QMISchema"],
});

//import RecentlyViewed from 'components/containers/RecentlyViewed';
const RecentlyViewed = Loadable({
  loader: () => import("components/containers/RecentlyViewed"),
  loading: () => <div> </div>,
  modules: ["RecentlyViewed"],
});

//import RegistrationModal from 'components/containers/RegistrationModal';
const RegistrationModal = Loadable({
  loader: () => import("components/containers/RegistrationModal"),
  loading: () => <div> </div>,
  modules: ["RegistrationModal"],
});

//import RegistrationPromo from 'components/containers/RegistrationPromo';
const RegistrationPromo = Loadable({
  loader: () => import("components/containers/RegistrationPromo"),
  loading: () => <div> </div>,
  modules: ["RegistrationPromo"],
});

//import ReverseComponentOrderContainer from 'components/containers/ReverseComponentOrderContainer';
const ReverseComponentOrderContainer = Loadable({
  loader: () => import("components/containers/ReverseComponentOrderContainer"),
  loading: () => <div> </div>,
  modules: ["ReverseComponentOrderContainer"],
});

//import ReverseComponentStaticCarousel from 'components/containers/ReverseComponentStaticCarousel';
const ReverseComponentStaticCarousel = Loadable({
  loader: () => import("components/containers/ReverseComponentStaticCarousel"),
  loading: () => <div> </div>,
  modules: ["ReverseComponentStaticCarousel"],
});

//import SalesCenterContact from 'components/containers/SalesCenterContact';
const SalesCenterContact = Loadable({
  loader: () => import("components/containers/SalesCenterContact"),
  loading: () => <div> </div>,
  modules: ["SalesCenterContact"],
});

//import SalesPerson from 'components/containers/SalesPerson';
const SalesPerson = Loadable({
  loader: () => import("components/containers/SalesPerson"),
  loading: () => <div> </div>,
  modules: ["SalesPerson"],
});

//import ScheduleAppointmentCTA from 'components/containers/ScheduleAppointmentCTA';
const ScheduleAppointmentCTA = Loadable({
  loader: () => import("components/containers/ScheduleAppointmentCTA"),
  loading: () => <div> </div>,
  modules: ["ScheduleAppointmentCTA"],
});

//import SearchFavorites from 'components/containers/SearchFavorites';
const SearchFavorites = Loadable({
  loader: () => import("components/containers/SearchFavorites"),
  loading: () => <div> </div>,
  modules: ["SearchFavorites"],
});

//import SectionBlue from 'components/containers/SectionBlue';
const SectionBlue = Loadable({
  loader: () => import("components/containers/SectionBlue"),
  loading: () => <div> </div>,
  modules: ["SectionBlue"],
});

//import SmallTitleAndText from 'components/containers/SmallTitleAndText';
const SmallTitleAndText = Loadable({
  loader: () => import("components/containers/SmallTitleAndText"),
  loading: () => <div> </div>,
  modules: ["SmallTitleAndText"],
});

//import SmallTitleTextVideo from 'components/containers/SmallTitleTextVideo';
const SmallTitleTextVideo = Loadable({
  loader: () => import("components/containers/SmallTitleTextVideo"),
  loading: () => <div> </div>,
  modules: ["SmallTitleTextVideo"],
});

//import SplitComponent from 'components/containers/SplitComponent';
const SplitComponent = Loadable({
  loader: () => import("components/containers/SplitComponent"),
  loading: () => <div> </div>,
  modules: ["SplitComponent"],
});

//import StandardPage from 'components/containers/StandardPage';
const StandardPage = Loadable({
  loader: () => import("components/containers/StandardPage"),
  loading: () => <div> </div>,
  modules: ["StandardPage"],
});

//import StaticCarousel from 'components/containers/StaticCarousel';
const StaticCarousel = Loadable({
  loader: () => import("components/containers/StaticCarousel"),
  loading: () => <div> </div>,
  modules: ["StaticCarousel"],
});

//import SubNavigationBar from 'components/containers/SubNavigationBar';
const SubNavigationBar = Loadable({
  loader: () => import("components/containers/SubNavigationBar"),
  loading: () => <div> </div>,
  modules: ["SubNavigationBar"],
});

//import SupportContacts from 'components/containers/SupportContacts';
const SupportContacts = Loadable({
  loader: () => import("components/containers/SupportContacts"),
  loading: () => <div> </div>,
  modules: ["SupportContacts"],
});

//import ThreeColumns from 'components/containers/ThreeColumns';
const ThreeColumns = Loadable({
  loader: () => import("components/containers/ThreeColumns"),
  loading: () => <div> </div>,
  modules: ["ThreeColumns"],
});

//import TimelineCarousel from 'components/containers/TimelineCarousel';
const TimelineCarousel = Loadable({
  loader: () => import("components/containers/TimelineCarousel"),
  loading: () => <div> </div>,
  modules: ["TimelineCarousel"],
});

//import TitleCTA from 'components/containers/TitleCTA';
const TitleCTA = Loadable({
  loader: () => import("components/containers/TitleCTA"),
  loading: () => <div> </div>,
  modules: ["TitleCTA"],
});

//import TitleDetailsBlock from 'components/containers/TitleDetailsBlock';
const TitleDetailsBlock = Loadable({
  loader: () => import("components/containers/TitleDetailsBlock"),
  loading: () => <div> </div>,
  modules: ["TitleDetailsBlock"],
});

//import VideoGallery from 'components/containers/VideoGallery';
const VideoGallery = Loadable({
  loader: () => import("components/containers/VideoGallery"),
  loading: () => <div> </div>,
  modules: ["VideoGallery"],
});

//import Visualizer from 'components/containers/Visualizer';
const Visualizer = Loadable({
  loader: () => import("components/containers/Visualizer"),
  loading: () => <div> </div>,
  modules: ["Visualizer"],
});

//import WideTextBanner from 'components/containers/WideTextBanner';
const WideTextBanner = Loadable({
  loader: () => import("components/containers/WideTextBanner"),
  loading: () => <div> </div>,
  modules: ["WideTextBanner"],
});

const components = new Map();

components.set("Amenities", Amenities);
components.set("AnchorCta", AnchorCTA);
components.set("AvailablePromos", AvailablePromos);
components.set("BackButton", BackButton);
components.set("BackButtonBar", BackButtonBar);
components.set("Banner", Banner);
components.set("BaseGallery", GallerySection);
components.set("Breadcrumb", Breadcrumb);
components.set("BreadcrumbSchema", BreadcrumbSchema);
components.set("ButtonCTA", ButtonCTA);
components.set("Cards", Cards);
components.set("ChatBot", ChatBot);
components.set("ColumnsBlock", ColumnsBlock);
components.set("CommunityCards", CommunityCards);
components.set("CommunityMap", CommunityMap);
components.set("CommunityProductOverview", CommunityProductOverview);
components.set("CommunitySchema", CommunitySchema);
components.set("CommunityStylesCards", CommunityStylesCards);
components.set("CondoiFrame", CondoiFrame);
components.set("CondoOptions", CondoOptions);
components.set("Contact Panel", ContactPanel);
components.set("ContactCards", ContactCards);
components.set("ContactWrapper", ContactUsPanel);
components.set("ContentBlock", ExpansionContent);
components.set("CountrySelector", CountrySelector);
components.set("CustomCare", CustomCare);
components.set("DisclaimerText", DisclaimerText);
components.set("DoubleMedia", DoubleMedia);
components.set("EloquaIntegrationData", EloquaIntegrationData);
components.set("Error", PageNotFound);
components.set("ExtendedGallery", ExtendedGallerySection);
components.set("ExteriorStyles", ExteriorStyles);
components.set("FAQs", FAQsContainer);
components.set("Favicon", Favicon);
components.set("FeaturesBlock", ExpansionFeatures);
components.set("FloatingAnchorLink", AnchorLinkBar);
components.set("FloorPlan", FloorPlan);
components.set("FloorplanSchema", FloorplanSchema);
components.set("Footer", Footer);
components.set("Form", Form);
components.set("FormsConfirmationModal", FormsConfirmationModal);
components.set("FormsTitle", FormsTitle);
components.set("FormsMarketCommunities", FormsMarketCommunities);
components.set("GalleryComponent", GalleryComponent);
components.set("generalscript", GeneralScript);
components.set("GenericFormContainer", GenericFormContainer);
components.set("GetInTouch", GetInTouch);
components.set("GetInTouchContainer", GetInTouchContainer);
components.set("GTM", GTM);
components.set("Header", Header);
components.set("HomeCutaway", HomeCutaway);
components.set("Home Buying Markets", MarketSelector);
components.set("HomeSpecsBlock", HomeSpecsBlock);
components.set("IconBlock", CommunityServices);
components.set("IFP", FloorPlan);
components.set("ImageVideo", ImageVideo);
components.set("ImageVideoForCareers", ImageVideoForCareers);
components.set("InteractiveSitemap", InteractiveSitemap);
components.set("InvestorRelationsForm", InvestorRelationsForm);
components.set("LargeTitleText", LargeTitleAndText);
components.set("LocationDetails", FloorPlan);
components.set("Market Selector", MarketSelector);
components.set("MarketCards", MarketCards);
components.set("MarketCardsWrapper", MarketCardsWrapper);
components.set("MarketDisclaimerText", DisclaimerText);
components.set("Masthead", Masthead);
components.set("MetroSearch", MetroSearch);
components.set("MortgageBanner", MortgageCalculator);
components.set("MultiBlocks", MultiBlocks);
components.set("MyHomeStory", MyHomeStory);
components.set("PromotionBanner", NationalPromoBanner);
components.set("NotificationBanner", NotificationBanner);
components.set("OpenGraph", OpenGraph);
components.set("PlanDescription", PlanDescription);
components.set("PortraitCards", PortraitCards);
components.set("ProductCarousel", ProductCarousel);
components.set("ProductDescription", ExpansionContent);
components.set("ProductHero", ProductHero);
components.set("ProductOverview", ProductOverview);
components.set("ProductSection", ProductSection);
components.set("Promo", Promo);
components.set("PromoBlock", PromoBlock);
components.set("PromosFlyout", PromosFlyout);
components.set("QMIBlock", RecentlyViewed);
components.set("QMISchema", QMISchema);
components.set("QMIInteractiveSitemap", InteractiveSitemap);
components.set("RegistrationModal", RegistrationModal);
components.set("RegistrationPromo", RegistrationPromo);
components.set(
  "ReverseComponentOrderContainer",
  ReverseComponentOrderContainer
);
components.set(
  "ReverseComponentStaticCarousel",
  ReverseComponentStaticCarousel
);
components.set("SalesCenterContact", SalesCenterContact);
components.set("SalesPerson", SalesPerson);
components.set("ScheduleAppointmentCTA", ScheduleAppointmentCTA);
components.set("SearchFavorites", SearchFavorites);
components.set("SectionBlue", SectionBlue);
components.set("SmallTitleLongText", SmallTitleAndText);
components.set("SmallTitleText", SmallTitleAndText);
components.set("SmallTitleTextVideo", SmallTitleTextVideo);
components.set("SplitComponent", SplitComponent);
components.set("StandardPage", StandardPage);
components.set("StaticCarousel", StaticCarousel);
components.set("SubNavigationBar", SubNavigationBar);
components.set("SupportContacts", SupportContacts);
components.set("ThreeColumns", ThreeColumns);
components.set("TimelineCarousel", TimelineCarousel);
components.set("TitleCTA", TitleCTA);
components.set("TitleDetailsBlock", TitleDetailsBlock);
components.set("UTourCTA", TitleCTA);
components.set("VariableWidthGallery", DynamicWidthGallerySection);
components.set("VideoGallery", VideoGallery);
components.set("Visualizer", Visualizer);
components.set("WideTextBanner", WideTextBanner);

export default function componentFactory(componentName) {
  return components.get(componentName);
}
